import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from 'components/UI/CustomButton/CustomButton';

import { BITRIX } from 'common/constants';
import classes from './EducationProcessComponent.module.scss';


const colors = {
  white: classes.whiteTitle,
  yellow: classes.title,
};

const EducationProcessComponent = (props) => {
  const { title = '', data = [], color = 'yellow', status = true } = props;
  const { t } = useTranslation();

  const cls = colors?.[ color ] || colors.yellow;
  if (!status) return;
  return (
    <Box className={classes.education}>
      <Container>
        <Box className={classes.howTrainingContainer}>
          <Box className={classes.howTrainingText}>
            <Typography
              className={classes.howTraining}
              data-aos='fade-up'
              data-aos-duration={800}
            >{title}</Typography>
            <CustomButton
              path={BITRIX.course}
              text={t('UpLesson')}
              theme="yellow"
              isArrow={true}
            />
          </Box>
          <Box className={classes.howTrainingContent}>
            {data?.map((itemEducation, i) =>
              <Box
                key={i}
                className={classes.eduItem}
                data-aos='fade-up'
                data-aos-duration={800}
                data-aos-delay={50 * (i % 2)}
              >
                <Typography className={cls}>
                  {itemEducation?.title}
                </Typography>
                <Typography className={classes.description}>
                  {itemEducation?.description}
                  {itemEducation?.text}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default EducationProcessComponent;
